import { render, staticRenderFns } from "./FileManager.vue?vue&type=template&id=6a1d18f6&"
import script from "./FileManager.vue?vue&type=script&lang=js&"
export * from "./FileManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kael-cadranel/Sites/apps.chateaudeseneffe.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a1d18f6')) {
      api.createRecord('6a1d18f6', component.options)
    } else {
      api.reload('6a1d18f6', component.options)
    }
    module.hot.accept("./FileManager.vue?vue&type=template&id=6a1d18f6&", function () {
      api.rerender('6a1d18f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/FileManager.vue"
export default component.exports